import Breadcrumb from "components/shared/breadcrumb";
import { productRoute } from "constants/config";
import UseFetch from "hooks/useFetch";
import { memo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import TextareaAutosize from 'react-textarea-autosize';
import { toast } from "react-toastify";
import { CSSTransition } from "react-transition-group";
import MasterAPI from "service/master";
import { commentStatus, unixToShamsi } from "utils";

const Detail = () => {
    const { id } = useParams();
    const { isLoading, error, data } = UseFetch(`/api/comment/get?id=${id}`);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [reply, setReply] = useState("");

    const submitHandler = async () => {
        if (submitLoading)
            return;

        if (reply.length === 0) {
            toast.error("پاسخی وارد نشده است");
            return;
        }

        setSubmitLoading(true);
        try {
            const res = await MasterAPI({
                url: "/api/comment/reply",
                method: "PUT",
                payloadType: 3,
                data: {
                    comment_id: data.data.id,
                    text: reply
                },
                callback: () => setSubmitLoading(false)
            });

            setReply("");
            toast.success(res.message);
        } catch (e) {
            toast.error(e);
        }
    }

    return (
        <>
            <div className="flex item-start md:items-center justify-start md:justify-between flex-col md:flex-row mb-10">
                <div className="mb-6 md:mb-0">
                    <h1 className="title-c1 tp-21">جزئیات نظر</h1>
                    <Breadcrumb data={[
                        { title: "تعاملات کاربران" },
                        { title: "نظرات", link: "/panel/comment" },
                        { title: "جزئیات نظر" }
                    ]} />
                </div>

                <div className="flex">
                    <Link to="/panel/comment" className="w-10 h-10 tp-22 text-[#424e79] dark:text-white ml-3 rounded-md fit-center" title="بروزرسانی">
                        <i className="fa-regular fa-arrow-right"></i>
                    </Link>

                    <button
                        className={`bg-primary-100 hover:bg-primary-200 px-4 transition-colors text-white rounded-md fit-center text-sm h-10 relative overflow-hidden${submitLoading ? " cursor-progress" : ""}`}
                        onClick={submitHandler}
                    >
                        <i className="fa-light fa-pen-to-square ml-2"></i>
                        ثبت پاسخ

                        <CSSTransition in={submitLoading} timeout={200} unmountOnExit={true}>
                            <span className="pos-cover bg-primary-200 fit-center anim-c4">
                                <i className="fa-solid fa-spinner spin"></i>
                            </span>
                        </CSSTransition>
                    </button>
                </div>
            </div>

            <div className="wrap-box tp-22">
                {
                    !isLoading ? (
                        !error ? (
                            <>
                                <div className="bg-yellow-100 flex items-center mb-5 rounded-md p-3 dark:bg-slate-800">
                                    <i className="fa-regular fa-circle-exclamation text-sm text-green-600 dark:text-green-300 ml-3"></i>

                                    <p className="text-sm text-green-800 dark:text-slate-300">
                                        <b className="inline-block ml-2">وضعیت نظر</b>
                                        <span>{commentStatus(data.data.status_id)}</span>
                                    </p>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>نام کاربر</span>
                                            <b>{data.data.name}</b>
                                        </li>

                                        <li className="inline">
                                            <span>کد کاربر</span>
                                            <b>{data.data.user_id}</b>
                                        </li>
                                    </ul>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li className="inline">
                                            <span>تاریخ ثبت</span>
                                            <b>{unixToShamsi(data.data.created_at)}</b>
                                        </li>

                                        <li className="inline">
                                            <a href={`${productRoute}/${data.data.content_id}`} target="_blank" className="text-blue-400 dark:text-slate-400" rel="noreferrer">
                                                <i className="fa-regular fa-share-from-square ml-2"></i>
                                                رفتن به محصول
                                            </a>
                                        </li>
                                    </ul>
                                </div>

                                <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                    <ul className="order-detail">
                                        <li>
                                            <span className="block mb-2">متن نظر</span>
                                            <p className="whitespace-pre-line">{data.data.text}</p>
                                        </li>
                                    </ul>
                                </div>

                                {
                                    data.data.replies?.length && (
                                        <div className="border-b border-gray-200 dark:border-slate-700 py-4">
                                            <ul className="order-detail">
                                                {
                                                    data.data.replies.map((reply, i) => (
                                                        <li className="block no-circle mb-3" key={`reply-${i}`}>
                                                            <ul className="order-detail">
                                                                <li className="inline">
                                                                    <span className="block mb-1">پاسخ {reply.user_kind === 2 ? "فروشنده" : "مدیر"}</span>
                                                                </li>

                                                                <li className="inline">
                                                                    <span className="block mb-1">{unixToShamsi(reply.created_at)}</span>
                                                                </li>

                                                                <li className="inline">
                                                                    <span className="block mb-1">{commentStatus(reply.status_id)}</span>
                                                                </li>
                                                            </ul>

                                                            <p className="whitespace-pre-line">{reply.text}</p>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    )
                                }

                                <div className="py-4">
                                    <span className="text-sm text-[#979797]">پاسخ {data.data.replies?.length ? "(پاسخ شما قبلا ثبت شده است و نیاز به پاسخ مجدد نمی باشد)" : ""}</span>

                                    <TextareaAutosize
                                        placeholder="وارد نمایید ..."
                                        className="reply-textarea"
                                        minRows={3}
                                        value={reply}
                                        onChange={e => setReply(e.target.value)}
                                    />
                                </div>
                            </>
                        ) : (
                            <></> // error
                        )
                    ) : (
                        <></> // loading
                    )
                }
            </div>
        </>
    )
}

export default memo(Detail);